import React, { useState, useEffect } from "react";
import { getOrdersCourierService } from "../../../services/courierServices"; // Adjust path as needed
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

const OrdersCourier = () => {
    const [gridData, setGridData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showCompleted, setShowCompleted] = useState(false);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const fetchOrders = async () => {
            setIsLoading(true);
            try {
                // showCompleted = false means we want onlyActive = true
                const res = await getOrdersCourierService(!showCompleted, page, limit);

                if (res.status === 200) {
                    setGridData(res.data.result?.orders || []);
                    setTotalPages(res.data.result?.totalPages || 1);
                }
            } catch (error) {
                toastErrorMessage("خطا در دریافت سفارشات");
            } finally {
                setIsLoading(false);
            }
        };

        fetchOrders();
    }, [showCompleted, page, limit]);

    if (isLoading) return <div className="text-center p-4">در حال بارگذاری...</div>;

    return (
        <div className="card border-0 shadow-sm mt-4">
            <SiteTitle title="سفارشات" />
            <div className="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                <h6 className="m-0 mb-0" style={{ fontSize: '15px', color: '#333', fontWeight: 'bold' }}>سفارشات من</h6>

                <div className="form-check m-0 d-flex align-items-center gap-2">
                    <input
                        className="form-check-input mt-0"
                        type="checkbox"
                        id="activeOrdersCheck"
                        checked={!showCompleted}
                        onChange={(e) => {
                            setShowCompleted(!e.target.checked);
                            setPage(1);
                        }}
                        style={{ cursor: "pointer" }}
                    />
                    <label className="form-check-label text-muted" htmlFor="activeOrdersCheck" style={{ fontSize: "13px", cursor: "pointer" }}>
                        فقط سفارشات فعال
                    </label>
                </div>
            </div>

            <div className="card-body p-0">
                <div className="table-responsive">
                    <table className="table table-bordered table-hover table-striped align-middle mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th style={{ textAlign: "right", width: "15%" }}>نام مشتری</th>
                                <th style={{ textAlign: "right", width: "15%" }}>موبایل مشتری</th>
                                <th style={{ textAlign: "right", width: "auto" }}>آدرس مشتری</th>
                                <th style={{ textAlign: "right", width: "20%" }}>توضیحات</th>
                                <th style={{ textAlign: "center", width: "10%" }}>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gridData.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-4 text-muted">سفارشی برای شما یافت نشد.</td>
                                </tr>
                            ) : (
                                gridData.map((row) => (
                                    <tr key={row._id} className={row.status === "DONE" ? "bg-success-subtle" : row.status === "CANCELLED" ? "bg-danger-subtle" : ""}>
                                        <td className="py-3 px-2" style={{ fontSize: "13px", fontWeight: "500" }}>{row.customerFirstName || "-"}</td>
                                        <td className="py-3 px-2" style={{ fontSize: "13px", direction: "ltr", textAlign: "right" }}>{row.customerPhoneNumber || "-"}</td>
                                        <td className="py-3 px-2" style={{ fontSize: "13px" }}>{row.customerAddress || "-"}</td>
                                        <td className="py-3 px-2" style={{ fontSize: "13px" }}>{row.description || "-"}</td>
                                        <td className="py-3 px-2 text-center fw-bold">
                                            <span className={row.status === "DONE" ? "text-success" : row.status === "CANCELLED" ? "text-danger" : "text-warning"}>
                                                {row.status === "DONE" ? "انجام شد" : row.status === "CANCELLED" ? "لغو شد" : "در حال انجام"}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination Footer */}
            <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center py-3">
                <div className="d-flex align-items-center gap-2">
                    <select
                        className="form-select form-select-sm shadow-none"
                        style={{ width: "80px", fontSize: "13px" }}
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                    </select>
                    <span className="text-muted" style={{ fontSize: "13px" }}>آیتم در هر صفحه</span>
                </div>

                <div className="d-flex align-items-center gap-3">
                    <button className="btn btn-sm btn-outline-secondary" disabled={page === 1} onClick={() => setPage(page - 1)}>قبلی</button>
                    <span style={{ fontSize: "13px" }}>صفحه {page} از {totalPages}</span>
                    <button className="btn btn-sm btn-outline-secondary" disabled={page === totalPages || totalPages === 0} onClick={() => setPage(page + 1)}>بعدی</button>
                </div>
            </div>
        </div>
    );
};

export default OrdersCourier;